export default {
	layout:null,
	loadingContent:true
}